import gql from "graphql-tag";
const getOwnerCalcsQuery = gql(` 
query getOwnerCalcs($user: String!) {
  queryGenoCalcsByOwner(user: $user) {
      items{user scaled calculator external aggregated type components samples description public download settings pca}
  } 
}   
`)
export default getOwnerCalcsQuery;
